import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setAuthToken, setAuthUser } from "../../../store/slices/Auth/authSlice";
import LocalstorageService from "../../../helpers/localstorage-service";

function SysAdminSidebar() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routePath = location.pathname;

  const handleBackToLogin = (e) => {
    e.preventDefault();
    // Clear all auth state
    localStorage.clear();
    dispatch(setAuthToken(null));
    dispatch(setAuthUser(null));
    navigate("/login");
  };

  const linkStyle = { color: "#3c4858" };
  const iconStyle = { color: "#5b6e88" };
  const activeLinkStyle = { color: "#2c5de5", fontWeight: "600" };

  const getLinkStyle = (isActive) => isActive ? activeLinkStyle : linkStyle;

  return (
    <div className="vertical-menu" style={{ background: "#e9ecf1", borderRight: "1px solid #d5dbe3" }}>
      <div data-simplebar className="h-100">
        <SimpleBar style={{ height: "100%", maxHeight: "100%" }}>
          <div id="sidebar-menu">
            <ul className="list-unstyled" id="side-menu">
              <li className="menu-title" style={{ color: "#5b6e88", fontWeight: "600", fontSize: "12px" }}>
                {t("SYSADMIN.MENU_TITLE") || "ניהול מערכת"}
              </li>

              {/* Dashboard */}
              <li className={routePath === "/sysadmin/dashboard" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/dashboard" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/dashboard")}>
                  <i className="ri-dashboard-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.DASHBOARD") || "דשבורד ניהול"}</span>
                </NavLink>
              </li>

              {/* Create Company */}
              <li className={routePath === "/sysadmin/company/create" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/company/create" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/company/create")}>
                  <i className="ri-add-circle-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.CREATE_COMPANY") || "הקמת חברה"}</span>
                </NavLink>
              </li>

              {/* Companies List — מפנה ל-Dashboard V2 שכולל companies grid */}
              <li className={routePath === "/sysadmin/dashboard" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/dashboard" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/dashboard")}>
                  <i className="ri-building-2-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.COMPANIES") || "ניהול חברות"}</span>
                </NavLink>
              </li>

              {/* Banks — מפנה ל-V2 (יוצא מ-SysAdmin layout) */}
              <li className={routePath.startsWith("/bank/list") ? "mm-active" : ""}>
                <NavLink to="/bank/list" className="waves-effect" style={getLinkStyle(routePath.startsWith("/bank/list"))}>
                  <i className="ri-bank-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.BANKS") || "ניהול בנקים"}</span>
                </NavLink>
              </li>

              {/* Special Days Config - ימים מיוחדים לחישוב */}
              <li className={routePath === "/sysadmin/special-days-config" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/special-days-config" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/special-days-config")}>
                  <i className="ri-calendar-event-line" style={iconStyle}></i>
                  <span className="ms-1">ימים מיוחדים לחישוב</span>
                </NavLink>
              </li>

              {/* לוח שנה — שבת וחגים */}
              <li className={routePath === "/sysadmin/calendar" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/calendar" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/calendar")}>
                  <i className="ri-calendar-2-line" style={iconStyle}></i>
                  <span className="ms-1">לוח שנה — שבת וחגים</span>
                </NavLink>
              </li>

              {/* Billing Report */}
              <li className={routePath === "/sysadmin/billing" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/billing" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/billing")}>
                  <i className="ri-file-chart-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.BILLING") || "דוח הודעות"}</span>
                </NavLink>
              </li>

              {/* Recognition Presets — אחוזי הכרה לחשבוניות (Iteration 5a) */}
              <li className={routePath === "/sysadmin/recognition-presets" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/recognition-presets" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/recognition-presets")}>
                  <i className="ri-percent-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.RECOGNITION_PRESETS_MENU") || "אחוזי הכרה"}</span>
                </NavLink>
              </li>

              {/* VAT Policy Modes — מצבי חישוב מע"מ (Iteration 5b) */}
              <li className={routePath === "/sysadmin/vat-policy-modes" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/vat-policy-modes" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/vat-policy-modes")}>
                  <i className="ri-scales-3-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.VAT_POLICY_MODES_MENU") || 'מצבי חישוב מע"מ'}</span>
                </NavLink>
              </li>

              {/* Company Setup Template — תבנית הקמת חברה (Iteration 5b) */}
              <li className={routePath === "/sysadmin/company-setup-template" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/company-setup-template" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/company-setup-template")}>
                  <i className="ri-file-copy-2-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.COMPANY_TEMPLATE_MENU") || "תבנית הקמת חברה"}</span>
                </NavLink>
              </li>

              {/* מרכז בקרת טיימרים */}
              <li className={routePath === "/sysadmin/timers" ? "mm-active" : ""}>
                <NavLink to="/sysadmin/timers" className="waves-effect" style={getLinkStyle(routePath === "/sysadmin/timers")}>
                  <i className="ri-timer-flash-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.TIMERS_MENU") || "מרכז בקרת טיימרים"}</span>
                </NavLink>
              </li>

              <li className="menu-title" style={{ color: "#5b6e88", fontWeight: "600", fontSize: "12px", marginTop: "20px" }}>
                {t("SYSADMIN.ACTIONS") || "פעולות"}
              </li>

              {/* Back to login - clears auth */}
              <li>
                <a href="/login" onClick={handleBackToLogin} className="waves-effect" style={linkStyle}>
                  <i className="ri-arrow-go-back-line" style={iconStyle}></i>
                  <span className="ms-1">{t("SYSADMIN.BACK_TO_LOGIN") || "חזרה לבחירת חברה"}</span>
                </a>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </div>
    </div>
  );
}

export default SysAdminSidebar;
